import ScaleLoader from 'react-spinners/ScaleLoader';
import './LoadingIndicator.scss';

export const LoadingIndicator = ({ show = false, blockInteractions = false }) => {
	if (!show) return null;

	return (
		<div
			className={blockInteractions ?
				"loading-indicator loading-indicator--blocking" :
				"loading-indicator"
			}
		>
			<ScaleLoader color="#e77512" />
		</div>
	);
};